import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DataThresholdingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"data_thresholding"}/>
}
